var React = require('react');
import { Link } from 'react-router-dom';

import ProcessManager from '../../../Common/Managers/ProcessManager';

import { GenericIconToggleButton, GenericIconButton } from 'com-gyf-webcore-userinterfacecomponents';

import PopUpBloqueado from './PopUpBloqueado.jsx';
import PopUpRecuperacion from './PopUpRecuperacion.jsx';
import PopUpBloqueadoConRazon from './PopUpBloqueadoConRazon.jsx';

const UsuarioLoginDetalle = (props) => {
    let editPlaceComponent = null;
    let deletePlaceComponent = null;
    let blockPlaceComponent = null;
    let backButton = null;
    let functionExport = undefined;

    let backToThePage = () => {
        sessionStorage.removeItem("idPerfilUsuario");
        sessionStorage.removeItem("idPerfil");
    }

    if (props.usuario != undefined && props.currentUser != props.usuario.Id) {
        deletePlaceComponent = (
            props.functions.Baja ?
                <button className="btn btn-icon btn-trash"
                    type="button" title="Eliminar al usuario"
                    onClick={() => props.setUserState(props.usuario.Id, false, false)}>
                    <span className="ti-trash"></span>
                </button> : null
        ) 

        if (sessionStorage.getItem("idPerfil") != null || sessionStorage.getItem("idPerfilUsuario") != null) {
            let idPerfil = sessionStorage.getItem("idPerfil") || sessionStorage.getItem("idPerfilUsuario");
            let ruta = sessionStorage.getItem("idPerfil") != null ? "ROUTE_TO_ASIGNAR_PERFIL_USUARIO" : "ROUTE_TO_USUARIO_PERFIL";
            backButton = (
                <div className="dropdown">
                    <Link className="btn-link btn-link-labeled-primary" onClick={() => backToThePage()} to={ProcessManager.GetNextStep("VistaDeUsuario", ruta) + "/" + idPerfil}>                        
                        &#60; Volver a la página anterior
                    </Link>
                </div>
            );
        }

        switch (props.estadoActual) {
            case 'ACTIVO':
                editPlaceComponent = (
                    <Link to={ProcessManager.GetNextStep("VistaDeUsuario", "ROUTE_TO_ALTA_MOD_USUARIO") + "/" + props.usuario.Id}>
                        <button className="btn btn-cta">Editar</button>
                    </Link>
                );

                blockPlaceComponent =
                    <div>
                        <button className="btn btn-icon btn-blocked" title="Bloquear al usuario" data-toggle="dropdown"
                            onClick={() => props.setUserState(props.usuario.Id, false, true)} data-target="#popUp-motivo-bloqueo">
                            <span className="ti-na"></span>
                        </button>
                        <PopUpBloqueadoConRazon
                            setMotivoBloqueo={props.setMotivoBloqueo}
                            usuario={props.usuario}
                        />
                    </div>

                break;
            case 'BLOQUEADO':
                editPlaceComponent = (<button className="btn btn-cta btn-cta-disabled"
                    title="No puede editar un usuario bloqueado">Editar</button>);

                blockPlaceComponent =
                    <div>
                        <PopUpBloqueado
                            functions={props.functions}
                            usuario={props.usuario}
                            setUserState={props.setUserState}
                        />
                        <PopUpBloqueadoConRazon
                            functions={props.functions}
                            usuario={props.usuario}
                            setMotivoBloqueo={props.setMotivoBloqueo}
                        />
                    </div>;

                break;
            case 'ELIMINADO':
                editPlaceComponent = (
                    <button className="btn btn-cta btn-cta-disabled" title="No puede editar un usuario eliminado">Editar</button>
                );

                deletePlaceComponent =
                    <PopUpRecuperacion
                        functions={props.functions}
                        usuario={props.usuario}
                        setUserState={props.setUserState}
                    />
                break;
            default:
                break;
        }
    }

    return (
        <div className="user-view">
            {backButton}
            {props.usuario != undefined &&
                <div className="info-details">
                    <div className="row bottom-separator-xs">
                        <div className="col-xs-12">
                            <h1>{props.usuario.Nombre}</h1>
                        </div>
                        {props.functions.Modificacion &&
                            <div className="col-xs-2">
                                {editPlaceComponent}
                            </div>
                        }
                        <div className="col-xs-1">
                            {blockPlaceComponent}
                        </div>
                        <div className="col-xs-2">
                            {deletePlaceComponent}
                        </div>
                        {functionExport &&
                            <div className="pull-right">
                                <GenericIconButton buttonType="btn btn-default btn-secondary-icon"
                                    iconType="glyphicon glyphicon-print" />
                            </div>
                        }
                    </div>
                    <div className="row bottom-separator-xs">
                        <div className="col-xs-2">
                            <label className="label-primary">Login</label>
                            <p>{props.usuario.Login}</p>
                        </div>
                    </div>
                    <div className="row bottom-separator-xs">
                        <div className="col-xs-2">
                            <label className="label-primary">Sucursal</label>
                            <p>{props.usuario.Sucursal}</p>
                        </div>
                        <div className="col-xs-2">
                            <label className="label-primary">Sector</label>
                            <p>{props.usuario.Sector}</p>
                        </div>
                    </div>
                    {props.usuario.NumeroDocumento &&
                        <div className="row bottom-separator-xs">
                            <div className="col-xs-2">
                                <label className="label-primary">Documento</label>
                                <p>{props.usuario.NumeroDocumento}</p>
                            </div>
                        </div>
                    }
                    <div className="row">
                        <div className="col-xs-12">
                            <label className="label-primary">Correo electrónico</label>
                            <p>{props.usuario.Email}</p>
                        </div>
                    </div>
                </div>}
        </div>
    )
}

export default UsuarioLoginDetalle;